import { makeVar } from "@apollo/client";

export interface AuthenticatedUser {
  email: string | null;
  displayName: string | null;
  emailVerified: boolean;
  uid: string;
}

export interface AuthenticationState {
  authenticated: boolean;
  user: AuthenticatedUser | null;
  selectedAccount: string;
  accounts: string[];
}

export const initialAuthenticationState: AuthenticationState = {
  authenticated: false,
  user: null,
  selectedAccount: "",
  accounts: [],
};

export const authenticationStateVar = makeVar<AuthenticationState>(
  initialAuthenticationState
);

export function setAuthenticationState(
  next: Partial<AuthenticationState>
): AuthenticationState {
  const merged: AuthenticationState = {
    ...authenticationStateVar(),
    ...next,
  };
  authenticationStateVar(merged);
  return merged;
}

export function resetAuthenticationState(): void {
  authenticationStateVar(initialAuthenticationState);
}
